import { render, staticRenderFns } from "./configuration.form.vue?vue&type=template&id=631e7f6b&"
import script from "./configuration.form.vue?vue&type=script&lang=ts&"
export * from "./configuration.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports